module.exports = __webpack_public_path__ + "static/media/Kindle Cover.9b135f57.jpg";